import {SettingsApiDto} from "../../api/model/rest";
import {none, Option, option} from "ts-option";

export default class Settings {
	constructor(public readonly googleMapsApiKey: string,
		public readonly bugsnagApiKey: string,
		public readonly environment: string,
		public readonly mixpanelApiKey: string,
		public readonly platformVersion: string,
		public readonly resetPasswordRedirectUrl: string,
		public readonly pubnubSettings: Option<PubNubSettings>,
		public readonly hiberWebsiteUrl: string,
		public readonly turnstileSiteKey: string,
		public readonly gaMeasurementId: string,
		public readonly partnersPortalUrl: string = "") {}

	public static fromJson(json: SettingsApiDto): Settings {

		return new Settings(json.googleMapsApiKey, json.bugsnagApiKey, json.environment, json.mixpanelApiKey,
			json.platformVersion, json.resetPasswordRedirectUrl, PubNubSettings.fromJson(json), json.hiberWebsiteUrl,
			json.turnstileSiteKey || "", json.gaMeasurementId || "", json.partnersPortalUrl || "");
	}
}

export class PubNubSettings {
	constructor(
		public readonly pubnubPublishKey: string,
		public readonly pubnubSubscribeKey: string) {}

	public static fromJson(json: SettingsApiDto): Option<PubNubSettings> {
		if (json.pubnubPublishKey && json.pubnubSubscribeKey) {
			return option(new PubNubSettings(json.pubnubPublishKey, json.pubnubSubscribeKey))
		}
		return none
	}
}

export enum Environment {
	Development = "development",
	FB1 = "fb1",
	FB2 = "fb2",
	Perf = "perf",
	Integration = "integration",
	Test = "test",
	Staging = "staging",
	GdStaging = "gd-staging",
	Production = "production",
	/**
	 * What production actually answers with. Checked against /settings on the live host: the
	 * configured value is "prod", and has been for as long as the portal has run there.
	 *
	 * {@link Environment#Production} is not a synonym of it. That one matches `process.env.NODE_ENV`,
	 * which webpack really does set to "production" - so the same enum is being compared against two
	 * different vocabularies, and only the build-time one ever said "production".
	 */
	Prod = "prod"
}
